<template>
  <KioskCenteredLayout :class="$style.container"
                       full-height>
    <div :class="$style.confirmWrapper">
      <div :class="$style.confirmText">
        <KioskMessageTitle :title="title" />
      </div>

      <div :class="$style.confirmButtons">
        <BaseButton :class="$style.noBtn"
                    button-style="Back"
                    @click="handleCancel">
          {{ cancelText }}
        </BaseButton>
        <BaseButton :class="$style.yesBtn"
                    button-style="Main"
                    @click="handleConfirm">
          {{ confirmText }}
        </BaseButton>
      </div>
    </div>
  </KioskCenteredLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskCenteredLayout from '@/layouts/KioskCenteredLayout';
import KioskMessageTitle from '@/components/KioskMessageTitle';
import BaseButton from '@/components/BaseButton';

/**
 * Provide confirm message
 */
@Component({
  components: {
    KioskCenteredLayout,
    KioskMessageTitle,
    BaseButton,
  },
  props: {
    title: {
      type:    String,
      default: 'Are you sure?',
    },
    confirmText: {
      type:    String,
      default: 'Yes',
    },
    cancelText: {
      type:    String,
      default: 'No',
    },
  },
})
export default class KioskConfirmMessage extends Vue {
  handleConfirm() {
    this.$emit('confirm');
  }

  handleCancel() {
    this.$emit('cancel');
  }
}
</script>

<style lang="scss" module>
@import '~@/style/variables.scss';
$text-bg: #2e2e2e;

.container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}

.confirmText {
  width: 441px;
  height: 441px;
  margin: 0 auto 96px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 12px solid $green-color;
  background-color: $text-bg;
  h2 {
    padding: 0 40px;
  }
}

.confirmWrapper .confirmButtons {
  display: flex;
  .noBtn,
  .yesBtn {
    flex: 1 0 0;
    padding: 0 50px;
    height: 100px;
    border-radius: 50px;
    div {
      color: $white;
      font-size: 30px;
      line-height: 38px;
    }
  }
  .noBtn {
    margin-right: 40px;
    &:hover,
    &:focus,
    &:active {
      background-color: transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskConfirmMessage.vue